import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { DocumentType } from '../../enum';
import { uploadAssets } from '../../utils/uploadAssets';
import { useAppSelector } from '../../store';
import { getAssetURl } from '../../utils/url';
import { useRemountFileInput } from '../../hooks/useRemountFileInput';

const ServiceCategoryFormModal = ({ toggle, onClose, formik }: any) => {
  const { handleSubmit, values, handleChange, errors, touched, isSubmitting, setFieldValue } =
    formik;
  const { accessToken } = useAppSelector((state) => state.auth);
  const assetUrl = useAppSelector((state) => state.active.selectedItem.assetUrl);
  const { fileInputRef, fileInputKey, clearFileInput } = useRemountFileInput(
    toggle,
    values?.id,
    Boolean(values?.image),
    'serviceCategoryImage'
  );

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.[0]) {
      const uploadResult: any = await uploadAssets(
        event.target.files[0],
        DocumentType.ServiceCategory,
        accessToken
      );
      if (uploadResult?.data?.id) {
        setFieldValue('image', uploadResult.data.keypath);
      }
    }
  };

  return (
    <Dialog open={toggle} onClose={onClose} fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{values.id ? 'Edit category' : 'New category'}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <TextField
              fullWidth
              label='Label English'
              name='labelEn'
              value={values.labelEn}
              onChange={handleChange}
              error={Boolean(errors.labelEn && touched.labelEn)}
              helperText={Boolean(errors.labelEn && touched.labelEn) && errors.labelEn}
            />
            <TextField
              fullWidth
              label='Label Arabic'
              name='labelAr'
              value={values.labelAr}
              onChange={handleChange}
              error={Boolean(errors.labelAr && touched.labelAr)}
              helperText={Boolean(errors.labelAr && touched.labelAr) && errors.labelAr}
            />
            <TextField
              fullWidth
              label='Position'
              name='position'
              value={values.position}
              onChange={handleChange}
            />
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                alignItems: 'flex-start',
              }}
            >
              <TextField
                key={fileInputKey}
                type='file'
                fullWidth
                name='image'
                id='serviceCategoryImage'
                inputRef={fileInputRef}
                onChange={handleFileChange}
                inputProps={{ multiple: false, accept: 'image/*' }}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
                label='Image'
              />
              {values.image ? (
                <Box
                  sx={{
                    position: 'relative',
                    width: { xs: '75px', sm: '100px' },
                    flexShrink: 0,
                    mt: 0.5,
                  }}
                >
                  <IconButton
                    size='small'
                    aria-label='remove image'
                    onClick={() => {
                      setFieldValue('image', '');
                      clearFileInput();
                    }}
                    sx={{
                      position: 'absolute',
                      top: -10,
                      right: -10,
                      zIndex: 1,
                      bgcolor: 'background.paper',
                      border: '1px solid',
                      borderColor: 'divider',
                      '&:hover': {
                        bgcolor: 'grey.100',
                      },
                    }}
                  >
                    <CloseIcon fontSize='small' />
                  </IconButton>
                  <Avatar
                    imgProps={{ crossOrigin: 'anonymous' }}
                    src={getAssetURl(values.image, assetUrl)}
                    sx={{
                      borderRadius: 'unset',
                      objectFit: 'contain',
                      '& img': { objectFit: 'contain' },
                      width: '100%',
                      height: 50,
                    }}
                  />
                </Box>
              ) : null}
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.activeState}
                  onChange={(e) => setFieldValue('activeState', e.target.checked)}
                />
              }
              label='Active Status'
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <LoadingButton type='submit' variant='contained' loading={isSubmitting}>
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ServiceCategoryFormModal;
